


















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateTask from "./createtask.vue";
import EditTask from "./edittask.vue";
import CopyTask from "./copytask.vue";
import Moment from "moment-timezone";
import checkAuth from "@/lib/Common/checkauth";
import SearchTree from "@/lib/Common/searchtree";

class PageTaskListRequest extends PageRequest {
    keyword: string;
    organizationId: number;
}

@Component({
    components: {
        CreateTask,
        EditTask,
        CopyTask,
    },
})
export default class TaskList extends AbpBase {
    //检测按钮权限
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    edit() {
        this.editModalShow = true;
    }
    //filters
    pagerequest: PageTaskListRequest = new PageTaskListRequest();
    searchName: string = ""; //树形搜索名称
    treedata: any[] = [];
    orgTreeList: any[] = [];
    createModalShow: boolean = false;
    editModalShow: boolean = false;
    copyModalShow: boolean = false;
    height: number = 300;
    loadingdata: boolean = false;
    splitnum: number = 0.15;

    changeSort(key) {
        if (key.order !== "normal") {
            this.pagerequest.sorting = key.key + " " + key.order;
        }
        this.getpage();
    }
    get list() {
        return this.$store.state.tasklist.list;
    }
    get loading() {
        return this.$store.state.tasklist.loading;
    }
    create() {
        this.createModalShow = true;
    }
    isActiveChange(val: number) {
        this.$store.commit("tasklist/setCurrentPage", 1);
        this.getpage();
    }
    getItemId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.organizationId = item[0].id;
        }
        this.$store.commit("tasklist/setCurrentPage", 1);
        this.getpage();
    }
    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.treedata = this.orgTreeList;
            return;
        }
        this.treedata = SearchTree.searnchTree(value, treeList);
    }
    //组织
    async getOrgTree() {
        await this.$store
            .dispatch("organization/getCommanyItemTree")
            .then((val) => {
                this.treedata = val;
                this.orgTreeList = val;
            })
            .catch((err) => {
                //return null;
            });
    }
    pageChange(page: number) {
        this.$store.commit("tasklist/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("tasklist/setPageSize", pagesize);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "tasklist/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.tasklist.pageSize;
    }
    get totalCount() {
        return this.$store.state.tasklist.totalCount;
    }
    get currentPage() {
        return this.$store.state.tasklist.currentPage;
    }
    columns = [
        {
            type: "index",
            width: 60,
            align: "left",
            fixed: "left",
            title: this.L("IndexNo"),
        },
        {
            type: "selection",
            width: 60,
            align: "center",
            fixed: "left",
        },
        {
            title: this.L("TaskName"),
            key: "taskName",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.taskName,
                        },
                    },
                    params.row.taskName
                );
            },
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            width: 130,
            sortId: 5,
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title:
                                    info.length > 0 ? info[0].displayName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].displayName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("TaskParams"),
            key: "taskParam",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.taskParam,
                        },
                    },
                    params.row.taskParam
                );
            },
        }, {
            title: this.L("CronExpressionString"),
            key: "cronExpressionString",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.cronExpressionString,
                        },
                    },
                    params.row.cronExpressionString
                );
            },
        }, {
            title: this.L("AssemblyName"),
            key: "assemblyName",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.assemblyName,
                        },
                    },
                    params.row.assemblyName
                );
            },
        },
        {
            title: this.L("ClassName"),
            key: "className",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.className,
                        },
                    },
                    params.row.className
                );
            },
        },
        {
            title: this.L("ClassName"),
            key: "className",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.className,
                        },
                    },
                    params.row.className
                );
            },
        },
        {
            title: this.L("State"),
            key: "status",
            width: 90,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                switch (params.row.status) {
                    case 0:
                        str = this.L("Stoped");
                        break;
                    case 1:
                        str = this.L("Runs");
                        break;
                }
                return h("span", str);
            },
        },
        {
            sortable: true,
            title: this.L("RecentRunTime"),
            key: "recentRunTime",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.recentRunTime == null
                        ? ""
                        : Moment(params.row.recentRunTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            sortable: true,
            title: this.L("NextFireTime"),
            key: "nextFireTime",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.nextFireTime == null
                        ? ""
                        : Moment(params.row.nextFireTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("CronRemark"),
            key: "cronRemark",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.cronRemark,
                        },
                    },
                    params.row.cronRemark
                );
            },
        },
        {
            title: this.L("Description"),
            key: "remark",
            width: 160,
            fixed: "left",
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.remark,
                        },
                    },
                    params.row.remark
                );
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 150,
            fixed: "right",
            sortId: 50,
            render: (h: any, params: any) => {
                let del = this.checkButtonAuth('taskDel');
                let edit = this.checkButtonAuth('taskEdit');
                let copy = this.checkButtonAuth('taskCopy');
                return h("div", [
                    edit ? h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.$store.commit("tasklist/edit", params.row);
                                    this.edit();
                                },
                            },
                        },
                        this.L("Edit")
                    ) : '',
                    del ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "tasklist/delete",
                                                data: params.row,
                                            });
                                            await this.getpage();
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ) : '',
                    copy ? h(
                        "Button",
                        {
                            props: {
                                type: "success",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.$store.commit("tasklist/edit", params.row);
                                    this.copy();
                                },
                            },
                        },
                        this.L("Copy")
                    ) : '',
                ]);
            },
        },
    ];
    async created() {
        this.getOrgTree();
        this.getpage();
    }
    //导出数据
    async exportData(type: any) {
        //console.log(type);
        let fileName = Moment().format("x");
        if (type === 'exportCurrentPage') {//当前页数据
            (this.$refs.selection as any).exportCsv({ filename: fileName, original: false });
        } else {
            this.pagerequest.skipCount = 0;
            this.pagerequest.maxResultCount = 10000;
            await this.$store.dispatch({
                type: "tasklist/getAll",
                data: this.pagerequest,
            });
            (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list });
        }
    }
    data() {
        return {
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
    //复制
    async copy() {
        this.copyModalShow = true;
    }
    mounted() {
        if (window.innerHeight > 800) {
            this.height = window.innerHeight - 350;
        } else {
            this.height = window.innerHeight - 100;
        }
    }
}
